import axios from 'axios';
import { isTokenExpired } from '../utils/jwtUtils';


// Use remote API if frontend is running on port 3001 or 3002
const frontendPort = window.location.port;
const useRemoteApi = frontendPort === '3001' || frontendPort === '3002';
const API_BASE_URL = useRemoteApi
  ? 'http://app.flipscout.fun:3000/api'
  : (process.env.REACT_APP_API_URL || '/api');

console.log('REACT_APP_API_URL', process.env.REACT_APP_API_URL);
console.log('API_BASE_URL', API_BASE_URL);
console.log('useRemoteApi', useRemoteApi);
console.log('frontendPort', frontendPort);


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for authentication (if needed)
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('authToken');
    if (token) {
      // Check if token is expired before making the request
      if (isTokenExpired(token)) {
        // Token expired, remove it and redirect to login
        localStorage.removeItem('authToken');
        sessionStorage.setItem('sessionExpired', 'true');
        window.location.href = '/login';
        return Promise.reject(new Error('Token expired'));
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Check for custom error format in successful HTTP responses
    if (response.data?.statusCode && response.data?.status === 'error') {
      console.log('Custom error in response body:', response.data);
      const customError = new Error(response.data.message);
      (customError as any).statusCode = response.data.statusCode;
      (customError as any).status = response.data.status;
      return Promise.reject(customError);
    }
    return response;
  },
  (error) => {
    console.log('API Error Interceptor:', error);
    console.log('Error response:', error.response);
    console.log('Error response data:', error.response?.data);

    // Handle unauthorized access (401 Unauthorized)
    if (error.response?.data?.statusCode === 401 || error.response?.status === 401) {
      localStorage.removeItem('authToken');
      // Store session expired message for login page
      sessionStorage.setItem('sessionExpired', 'true');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    // Handle custom error response format with statusCode and message
    if (error.response?.data?.statusCode && error.response?.data?.message) {
      console.log('Handling custom error format:', error.response.data);
      const customError = new Error(error.response.data.message);
      (customError as any).statusCode = error.response.data.statusCode;
      (customError as any).status = error.response.data.status;
      return Promise.reject(customError);
    }

    // Handle standard HTTP errors (like 404, 500, etc.)
    if (error.response?.status) {
      console.log('Handling standard HTTP error:', error.response.status);
      const status = error.response.status;
      const statusText = error.response.statusText || 'Unknown error';
      const message = error.response.data?.message || `${status} ${statusText}`;
      const customError = new Error(message);
      (customError as any).statusCode = status;
      (customError as any).status = 'error';
      return Promise.reject(customError);
    }

    return Promise.reject(error);
  }
);


export default api;
